.uic-loader {
  display: flex;
  height: 100%;
}

.uic-loader__bar {
  align-self: center;
  background-color: transparent;
  flex: auto;
  overflow: hidden;
  position: relative;
  // measurement
  width: 100%;

  @media #{$breakpoint_tablet} {
    height: 12px;
  }

  @media #{$breakpoint_desktop} {
    height: 15px;
  }

  &::before {

    animation: loading 4s ease-in-out infinite alternate;
    background-color: var(--uic-color-blue4);
    content: '';
    display: block;

    // measurement
    height: 100%;
    width: 100%;
  }

  &.uic-loader--light::before {
    background-color: var(--uic-color-white);
  }

  @keyframes loading {
    0.001% {
      // IE hack to prevent flickering
      transform: translateX(-98%); // IE
      transform: translateX(calc(-100% + 15px));
    }

    0% {
      transform: translateX(-98%); // IE
      transform: translateX(calc(-100% + 15px));
    }

    5% {
      transform: translateX(-98%); // IE
      transform: translateX(calc(-100% + 15px));
    }

    50% {
      transform: translateX(0);
    }

    95% {
      transform: translateX(98%); // IE
      transform: translateX(calc(100% - 15px));
    }

    100% {
      transform: translateX(98%); // IE
      transform: translateX(calc(100% - 15px));
    }
  }
}
